// src/models/pedidos/TaxaEntregaBairro.js
import { normalizarTextoComparacao } from '../../utils/TextoUtils';

export class TaxaEntregaBairro {
  static encontrarPorEndereco(endereco, taxas = []) {
    if (!endereco?.cidadeId) return null;
    const bairro = normalizarTextoComparacao(endereco.bairro);
    if (!bairro) return null;

    return taxas.find((taxa) =>
      Number(taxa.cidadeId) === Number(endereco.cidadeId) &&
      normalizarTextoComparacao(taxa.descricao) === bairro
    ) || null;
  }

  constructor(id = 0, cidadeId = 0, descricao = '', valor = 0, cidadeNome = '', cidadeUf = '') {
    this.id = id;
    this.cidadeId = cidadeId;
    this.descricao = descricao;
    this.valor = valor;
    this.cidadeNome = cidadeNome;
    this.cidadeUf = cidadeUf;
  }
}
